import { GlobalState } from "src/reducers";

export const selectLayoutTheme = (state: GlobalState) => {
    return state.ui.layout.theme;
};
